import { Injectable, inject } from '@angular/core';
import { EnvToken } from '@app/core/env.tokens';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class RecyclingService {
  protected readonly env = inject(EnvToken);

  baseHref = `${this.env.dashboardBaseRef}api/${this.env.apiPrefix}recycling`;
  constructor(private http: HttpClient) {}

  /**
   * Get recycling centers by city
   */
  getRecyclingCentersByCity(
    regionSlug: string,
    citySlug: string,
  ): Observable<any> {
    const url = `${this.baseHref}/centers/${regionSlug}/${citySlug}`;
    return this.http.get<any>(url);
  }

  /**
   * Get bulky waste information by city
   */
  getBulkyWasteByCity(regionSlug: string, citySlug: string): Observable<any> {
    const url = `${this.baseHref}/bulky-waste/${regionSlug}/${citySlug}`;
    return this.http.get<any>(url);
  }

  /**
   * Get recycling station details
   */
  getRecyclingStationDetail(
    regionSlug: string,
    citySlug: string,
    recyclingStationAddressSlug: string,
  ): Observable<any> {
    const url = `${this.baseHref}/station/${regionSlug}/${citySlug}/${recyclingStationAddressSlug}`;
    return this.http.get<any>(url);
  }

  /**
   * Get Garden Trash city
   */
  getGardenTrashDetail(regionSlug: string, citySlug: string): Observable<any> {
    const url = `${this.baseHref}/garden/${regionSlug}/${citySlug}`;
    return this.http.get<any>(url);
  }

  /**
   *  Index pages
   */
  getRecyclingDetailsIndexData(): Observable<any> {
    const url = `${this.baseHref}/index/recycling-details`;
    return this.http.get<any>(url);
  }

  getCityRecyclingOverviewIndexData(): Observable<any> {
    const url = `${this.baseHref}/index/recycling-overview-city`;
    return this.http.get<any>(url);
  }

  getGardenTrashCityIndexData(): Observable<any> {
    const url = `${this.baseHref}/index/garden-trash-city`;
    return this.http.get<any>(url);
  }

  getBulkTrashIndexData(): Observable<any> {
    const url = `${this.baseHref}/index/bulk-trash-city`;
    return this.http.get<any>(url);
  }

  /**
   * Consolidated affald hub hierarchy (region → kommune → by) backing
   * /affald/hub. Replaces the four separate index endpoints as the single
   * crawl entry point.
   */
  getAffaldHub(): Observable<AffaldHubRegion[]> {
    const url = `${this.baseHref}/hub`;
    return this.http.get<AffaldHubRegion[]>(url);
  }
}

export interface AffaldHubLeaves {
  genbrugsstationer: boolean;
  storskrald: boolean;
  haveaffald: boolean;
}

export interface AffaldHubCity {
  citySlug: string;
  city: string;
  leaves: AffaldHubLeaves;
}

export interface AffaldHubMunicipality {
  municipality: string;
  municipalityCode: number | null;
  cities: AffaldHubCity[];
}

export interface AffaldHubRegion {
  regionSlug: string;
  regionName: string;
  municipalities: AffaldHubMunicipality[];
}
